import React from "react";
import { Col, Row } from "react-bootstrap";

function Techstack() {
  return (
    <Row style={{ justifyContent: "", paddingBottom: "50px" }}>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        HTML/CSS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        JavaScript
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        TypeScript
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        React JS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Next JS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Tailwind CSS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Node JS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Express JS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Python
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Java
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        C/C++
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Solidity
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Hardhat
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Web3 JS
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Git/Github
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        Firebase
      </Col>
      <Col xs={1} style={{width:"10%"}} className="tech-icons">
        MySQL
      </Col>
    </Row>
  );
}

export default Techstack;
